/**
 * Help Center bylines: Defera's SI leaders, the same nine (names, public
 * titles, portraits) About Us introduces as "super intelligence agents".
 * Every byline's SI badge carries that disclosure (AI_AUTHOR_DISCLOSURE) as
 * its tooltip, and the Help Center home shows it beside the full list, as
 * aiLeadership.js asks wherever the list is reused.
 */
import { AI_LEADERSHIP } from '../../data/aiLeadership.js';

export const AI_AUTHOR_DISCLOSURE =
  'Written by one of Defera’s super intelligence agents: AI that leads a part of the business and reports to our leadership team.';

/** The same disclosure, for the Help Center home's list of all nine. */
export const SI_LEADERS_DISCLOSURE =
  'Our SI leaders are Defera’s super intelligence agents: AI that each lead a part of the business and report to our leadership team.';

export const HELP_AUTHORS = Object.freeze(
  Object.fromEntries(AI_LEADERSHIP.map((p) => [p.id, Object.freeze({ ...p })])),
);

export function getAuthor(id) {
  return HELP_AUTHORS[id] || null;
}
